// extracted by mini-css-extract-plugin
export var calendarView = "_50-0";